export default "__VITE_ASSET__Dfd2URlv__"